<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :width="width"
    :close-on-click-modal="false"
    :destroy-on-close="destroyOnClose"
    @open="open"
    @opened="opened"
    @close="close"
    @closed="closed"
  >
    <template #title>
      <div class="frame-top-left" />
      <div class="frame-top-right" />
      <div class="dialog-title">
        {{ title }}
      </div>
      <div v-if="existsRequired" class="required-description"><span>－必須</span></div>
    </template>
    <slot name="form" />
    <template #footer>
      <div class="footer-inner">
        <slot name="footer" />
      </div>
      <div class="frame-bottom-left" />
      <div class="frame-bottom-right" />
    </template>
  </el-dialog>
</template>

<script>
export default {
  components: {
  },
  props: {
    title: String,
    width: String,
    visible: Boolean,
    destroyOnClose: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      existsRequired: false,
      tabStopElements: []
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  updated () {
    const el = this.$el
    const dialog = el.querySelector('.el-dialog')
    this.$nextTick(() => {
      this.$nextTick(() => {
        const dialogRect = dialog.getBoundingClientRect()
        dialog.style.setProperty('--dialog-height', dialogRect.height + 'px')
      })
    })
  },
  methods: {
    open () {
      const el = this.$el
      const dialog = el.querySelector('.el-dialog')
      this.$nextTick(() => {
        const dialogRect = dialog.getBoundingClientRect()
        dialog.style.setProperty('--dialog-height', dialogRect.height + 'px')
        const requiredElements = dialog.querySelectorAll('.is-required')
        if (requiredElements.length > 0) {
          this.existsRequired = true
        }
        this.$root.$el.querySelectorAll('input, button, textarea, li, a, select, [tabindex]').forEach((x) => {
          this.tabStopElements.push({ el: x, tabIndex: x.getAttribute('tabindex') })
          x.tabIndex = -1
        })
        const focusElement = el.querySelector('[autofocus]')
        if (focusElement) {
          focusElement.focus()
        }
      })
      this.$emit('open')
    },
    opened () {
      this.$emit('opened')
    },
    close () {
      this.tabStopElements.forEach((x) => {
        if (!x.tabIndex) {
          x.el.removeAttribute('tabindex')
        } else {
          x.el.tabIndex = x.tabIndex
        }
      })
      this.tabStopElements = []
      this.$emit('close')
    },
    closed () {
      this.$emit('closed')
    }
  },
  mounted () {
    const el = this.$el
    document.body.appendChild(el)
  }
}
</script>
<style lang="scss">
$frame-size: 20px;
.el-dialog__wrapper {
  .el-dialog {
    --dialog-height: 100%;
    border-radius: $frame-size;
    background-color: transparent;
    box-shadow: none;
    .el-dialog__header {
      position: sticky;
      top: 0;
      z-index: 2200;
      border-radius: $frame-size;
      .frame-top-left {
        position: absolute;
        top: 0;
        left: 0;
        width: $frame-size;
        background-color: var(--background-color);
        border-top-left-radius: $frame-size;
        box-shadow: -3px -2px 3px -3px rgba(0,0,0,.3);
        // height: calc(var(--dialog-height) * 0.6);
        height: calc(var(--dialog-height) * 0.85);
        max-height: 60vh;
      }
      .frame-top-right {
        position: absolute;
        top: 0;
        right: 0;
        width: $frame-size;
        background-color: var(--background-color);
        border-top-right-radius: $frame-size;
        box-shadow: 3px -2px 3px -3px rgba(0,0,0,.3);
        // height: calc(var(--dialog-height) * 0.6);
        height: calc(var(--dialog-height) * 0.85);
        max-height: 60vh;
      }
      .dialog-title {
        order: 2;
        font-weight: bold;
        font-size: x-large;
        background-color: var(--background-color);
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        margin: -20px;
        padding: 20px;
        box-shadow: 0 -2px 3px -3px rgba(0,0,0,.3);
      }
      .required-description {
        position: absolute;
        left: 2em;
        &::before {
          content: "●";
          color: #f56c6c;
        }
        span {
          font-size: 70%;
        }
      }
      .el-dialog__headerbtn {
        font-size: xx-large;
      }
    }
    .el-dialog__body {
      margin: 0 20px;
      padding: 20px 1em;
      background-color: var(--background-color);
      .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before,
      .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
        content: none;
      }
      .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label::after,
      .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label::after {
        content: "●";
        color: #f56c6c;
        margin-left: 4px;
        float: right;
      }
      div.el-form--inline {
        display: flex;
        justify-content: space-between;
        .el-form-item {
          display: flex;
          margin-right: 0;
          @for $i from 2 through 12 {
            &:nth-last-child(#{$i}) {
              &,
              & ~ .el-form-item {
                width: calc((100% - (20px * #{$i - 1})) / #{$i});
              }
            }
          }
          .el-form-item__content {
            flex: 1;
            > *:not(.el-form-item__error) {
              width: auto;
            }
          }
        }
      }
    }
    .el-dialog__footer {
       position: sticky;
       bottom: 0;
       z-index: 2200;
      .frame-bottom-left {
        position: absolute;
        bottom: 0;
        left: 0;
        width: $frame-size;
        background-color: var(--background-color);
        border-bottom-left-radius: $frame-size;
        box-shadow: -3px 4px 3px -3px rgba(0,0,0,.3);
        // height: calc(var(--dialog-height) * 0.6);
        height: calc(var(--dialog-height) * 0.85);
        max-height: 60vh;
      }
      .frame-bottom-right {
        position: absolute;
        bottom: 0;
        right: 0;
        width: $frame-size;
        background-color: var(--background-color);
        border-bottom-right-radius: $frame-size;
        box-shadow: 3px 4px 3px -3px rgba(0,0,0,.3);
        // height: calc(var(--dialog-height) * 0.6);
        height: calc(var(--dialog-height) * 0.85);
        max-height: 60vh;
      }
      .footer-inner {
        background-color: var(--background-color);
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
        margin: -20px;
        padding: 20px;
        box-shadow: 0 4px 3px -3px rgba(0,0,0,.3);
      }
    }
  }
}
</style>
